import classNames from 'classnames';
import { Icon } from 'framework/Icon';

import { EMPTY_FUNCTION } from '../../constants';

import { TabProps, TabsProps } from './types';

import cn from './Tabs.module.scss';

export const Tabs = ({ padding, children }: TabsProps) => {
  return (
    <div className={cn.tabs} style={{ padding }}>
      {children}
    </div>
  );
};

Tabs.Tab = ({ label = '', onClick = EMPTY_FUNCTION, icon, active, is_hidden }: TabProps) => {
  if (is_hidden) return null;
  return (
    <div className={classNames(cn.tab, { [cn.active]: active })} onClick={onClick}>
      <p className={cn.label}>
        {icon && <Icon icon={icon} width="fit-content" />}
        {label}
      </p>
      <div className={cn.border} />
    </div>
  );
};
